module.exports = __webpack_public_path__ + "img/CersoLeekInkBlue.a10f9ec5.png";